import { Controller } from "@hotwired/stimulus"
import { select2RemoteAjax } from "../src/select2_remote"

// select2 の connect/disconnect。turbo:before-cache でも destroy する。
// キャッシュスナップショットより先に DOM を元の <select> に戻すため。
export default class extends Controller {
  static values = {
    placeholder: String,
    allowClear: { type: Boolean, default: false },
    language: { type: String, default: "ja" },
    width: String,
    dropdownParent: String,
    dropdownCssClass: String,
    ajaxUrl: String,
    ajaxQueryKey: { type: String, default: "search_text_cont_all" },
    ajaxResponseKey: String,
    ajaxResultTextKey: String,
    minimumInputLength: Number
  }

  connect() {
    this.destroySelect2()
    this.beforeCache = this.destroySelect2.bind(this)
    document.addEventListener("turbo:before-cache", this.beforeCache)
    window.jQuery(this.element).select2(this.buildOptions())
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.destroySelect2()
  }

  destroySelect2() {
    const $el = window.jQuery(this.element)
    if ($el.data("select2")) {
      $el.select2("destroy")
    }
  }

  buildOptions() {
    const options = { language: this.languageValue }
    if (this.hasPlaceholderValue) options.placeholder = this.placeholderValue
    if (this.allowClearValue) options.allowClear = true
    if (this.hasWidthValue) options.width = this.widthValue
    if (this.hasDropdownCssClassValue) options.dropdownCssClass = this.dropdownCssClassValue
    if (this.hasMinimumInputLengthValue) options.minimumInputLength = this.minimumInputLengthValue

    if (this.hasDropdownParentValue) {
      const parent = this.dropdownParentValue
      options.dropdownParent = parent === "closest-modal"
        ? window.jQuery(this.element).closest(".modal")
        : window.jQuery(parent)
    }

    if (this.hasAjaxUrlValue) {
      options.ajax = select2RemoteAjax({
        url: this.ajaxUrlValue,
        query: (params) => this.ajaxQueryKeyValue === "q"
          ? params.term
          : { [this.ajaxQueryKeyValue]: params.term },
        responseKey: this.ajaxResponseKeyValue,
        resultTextKey: this.ajaxResultTextKeyValue
      })
    }

    return options
  }
}
